import { render, staticRenderFns } from "./asset-group-category-asset-group-form.vue?vue&type=template&id=03f08975"
import script from "./asset-group-category-asset-group-form.vue?vue&type=script&lang=js"
export * from "./asset-group-category-asset-group-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports